module.exports = __webpack_public_path__ + "static/media/login-bg.31fc9455.png";